import { combineReducers } from "redux"

import socket from "./socket"
import login from "./login"
import loggedUser from "./loggedUser"
import users from "./users"
import company from "./company"
import members from "./members"
import project from "./project/project/project"
import workstream from "./workstream"
import task from "./task"
import notes from "./notes"
import type from "./type"
import role from "./role"
import status from "./status"
import teams from "./teams"
import global from "./global"
import document from "./document"
import settings from "./settings/settings"
import conversation from "./conversation"
import starred from "./starred"
import folder from "./folder"
import reminder from "./reminder"
import usersTeam from "./usersTeam"
import checklist from "./checklist"
import activityLog from "./activityLog"
import filters from "./filters"
import taskDependency from "./taskDependency"
import tasktimeLog from "./tasktimeLog"
import activityLogDocument from "./activityLogDocument"
import notification from "./notifications/notifications"
import screenLoader from "./screenLoader";
import common from "./common"

import projectDashboard from "./project/dashboard";
import projectMilestone from "./project/milestone";
import processes from "./project/processes/processes";
import processesTasks from "./project/processes/tasks/tasks";
import workstreams from "./project/workstream";
import workstreamForm from "./workstream/form";
import files from "./project/files/files";
import projectSettings from "./project/settings";
import conversations from "./project/conversation";
import fileupload from "./project/fileupload/fileupload";
import renameModal from "./project/renameModal/renameModal";
import comments from "./project/comments/comments";
import tagFileWorkstream from "./project/tagFileWorkstream/tagFileWorkstream";

import reports from "./reports/reports";
import dashboard from "./dashboard";

import templateTaskList from "./template/taskList";
import timelog from "./timelog"
import timelogPortfolio from "./timelogPortfolio"
import globalConfig from "./globalConfig"
import toast from "./toast/toast";
import taskForm from "./tasks/taskForm/taskForm";

export default combineReducers({
    socket,
    login,
    loggedUser,
    users,
    company,
    common,
    project,
    type,
    role,
    status,
    teams,
    workstream,
    members,
    global,
    document,
    task,
    notes,
    settings,
    conversation,
    starred,
    folder,
    reminder,
    usersTeam,
    checklist,
    activityLog,
    filters,
    taskDependency,
    activityLogDocument,
    tasktimeLog,
    notification,
    screenLoader,
    projectDashboard,
    projectMilestone,
    processes,
    processesTasks,
    workstreams,
    files,
    projectSettings,
    reports,
    templateTaskList,
    dashboard,
    workstreamForm,
    conversations,
    timelog,
    globalConfig,
    timelogPortfolio,
    fileupload,
    renameModal,
    comments,
    tagFileWorkstream,
    toast,
    taskForm,
})